var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"faq-page",attrs:{"id":"faq-container"}},[_c('c-faq')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }